import { render } from "./activeryList.vue?vue&type=template&id=8ea945fe&scoped=true"
import script from "./activeryList.vue?vue&type=script&lang=js"
export * from "./activeryList.vue?vue&type=script&lang=js"

import "./activeryList.vue?vue&type=style&index=0&id=8ea945fe&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ea945fe"]])

export default __exports__